import React, { useEffect, useState } from "react";
import Avatar from "../Avatar/Avatar.js";

import "./toolbar.scss";
// font awesome Icons

import { FaBars, FaXmark } from "react-icons/fa6";

import { useNavigate } from "react-router-dom";
import CircularProgress from "../ProgressBar/CircularProgressBar.js";
import LogOutDialogue from "../LogOutDialogue/LogOutDialogue.jsx";
import GoogleMapComponent from "../GoogleMap/GoogleMap.jsx";
import { IoNotificationsOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { toggleNotification } from "../../store/Partner/modalSlice.js";
import notifications from "../../assets/images/svg/notifications.png";

const Toolbar = ({ showSidebar, setShowSideBar, userData }) => {
  const [sliderValue, setSliderValue] = useState(0);
  const [showProfileDetails, setShowProfileDetails] = useState(false);
  const [openLocSelector, setOpenLocSelector] = useState(false);
  const [showCity, setShowCity] = useState("");

  const [userLocation, setUserLocation] = useState(null);
  // const [showGoogleMap, setShowGoogleMap] = useState(false);
  const showGoogleMap = useSelector((state) => state.modal.showGoogleMap);
  const [imgLoaded, setImgLoaded] = useState(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (userData && userData?.partner?.location) {
      console.log("User Data!", userData.partner.location.local_area);

      setUserLocation(userData.partner.location.local_area);
    }
    console.log(userData);
  }, [userData]);

  const profileCompletionPercent = useSelector(
    (state) => state.partner.profilePercentage
  );

  return (
    <div className="toolbar">
      <div className="mobile-sidebar-switch">
        <FaBars
          onClick={() => setShowSideBar(!showSidebar)}
          className="hamburger-icon"
        />
      </div>

      {userData?<span className="toolbar-name">{userData.name}</span>:<></>}
      {/* <div className="toolbar-center">
        <img src={logo} alt="Logo" className="toolbar-logo" />
      </div> */}
      <div className="menu">
        {/* <div
          className="sm-button"
          onClick={() => {
            setOpenLocSelector(true);
            setOpenDistSelector(false);
            setShowGoogleMap(true);
            navigate('/dashboard/partner')
          }}
        >
          <span>
            {userLocation ? userLocation : "Select Location"}
          </span>
        </div>
        {showGoogleMap && (
          <GoogleMapComponent
            setUserLocation={setUserLocation}
          />
        )} */}

        {/* Notifications */}
        {/* <div
          className="notificationContainer"
          onClick={() => {
            
            dispatch(toggleNotification())
          }}
        >
          <IoNotificationsOutline className="notification" />
        </div> */}
          
          <div
    className="notificationContainer"
    onClick={() => dispatch(toggleNotification())}
  >
    <IoNotificationsOutline className="notification" />
  </div>

        <div className="profileImgContainer">
          <CircularProgress
            className="percentageSvg"
            percentage={profileCompletionPercent}
            size={50}
            strokeWidth={5}
          />
          <div
            className="profileImg"
            onClick={() => {
              setShowProfileDetails(true);
            }}
          >
            
            {userData ? (
              imgLoaded ? (
                <img
                  src={userData.profile_img}
                  alt=""
                  onError={(e) => {
                    e.target.style.display = "none";
                    setImgLoaded(false);
                  }}
                />
              ) : (
                <Avatar
                  fontSize={"15px"}
                  name={userData ? userData.name : "Fetching..."}
                />
              )
            ) : (
              <Avatar
                name={userData ? userData.name : "Fetching..."}
                width="40px"
                height="40px"
                setShowProfileDetails={setShowProfileDetails}
                hover={"true"}
              />
            )}
          </div>
        </div>
        {showProfileDetails && (
          <LogOutDialogue
            userData={userData}
            showProfileDetails={showProfileDetails}
            setShowProfileDetails={setShowProfileDetails}
          />
        )}
      </div>
    </div>
  );
};

export default Toolbar;
